const ua = navigator.userAgent.toLowerCase();
let UA = {};
let s = null;
UA.ie = (s = ua.match(/(msie\s|trident.*rv:)([\d.]+)/)) ? s[2] : false;
UA.firefox = (s = ua.match(/firefox\/([\d.]+)/)) ? !!s[1] : false;
UA.chrome = (s = ua.match(/chrome\/([\d.]+)/)) ? !!s[1] : false;
UA.opera = (s = ua.match(/opera.([\d.]+)/)) ? !!s[1] : false;
UA.safari = (s = ua.match(/version\/([\d.]+).*safari/)) ? !!s[1] : false;
UA.android = (s = ua.match(/android/)) ? !!s : false;
UA.iphone = (s = ua.match(/iphone os/)) ? !!s : false;
UA.ipad = (s = ua.match(/ipad/)) ? !!s : false;
UA.ios = UA.ipad || UA.iphone;
UA.isMobile = UA.android || UA.iphone;
UA.isWin32 = /win32/i.test(window.navigator.platform);
UA.isWeixin = (s = ua.match(/MicroMessenger/i)) ? !!s : false; //判断是否是在微信浏览器里面
UA.isAli = (s = ua.match(/AlipayClient/i)) ? !!s : false; //判断是否是在支付宝浏览器里面
UA.isUcweb = (s = ua.match(/ucbrowser/)) ? !!s : false;
UA.isMqq = navigator.userAgent.indexOf("QQ") !== -1;
UA.isWeiBo = (s = ua.match(/__weibo__/)) ? !!s : false; //是否微博浏览器
UA.winClient = (s = ua.match(/winclient/i)) ? !!s : false; //是否pc客户端
UA.androidClient = (s = ua.match(/ACAndroidClient/i)) ? !!s : false; //是否安卓客户端
UA.androidTabClient = (s = ua.match(/ACAndroidTabClient/i)) ? !!s : false; //是否安卓平板客户端
UA.ipadClient = (s = ua.match(/ACIPadClient/i)) ? !!s : false; //是否ipad客户端
UA.iphoneClient = (s = ua.match(/ACiphoneclient/i)) ? !!s : false; //是否ipone客户端
UA.iosClient = UA.ipadClient || UA.iphoneClient; //是否ios客户端
UA.mobileClient = UA.iphoneClient || (UA.androidClient && !UA.androidTabClient); //是否手机客户端
UA.ACClient = UA.iosClient || UA.winClient || UA.androidClient; //是否客户端

export default UA;



// WEBPACK FOOTER //
// ./src/utils/ua.js